import { render, staticRenderFns } from "./MapPlantsLandowners.vue?vue&type=template&id=59bd73ee"
import script from "./MapPlantsLandowners.vue?vue&type=script&lang=js"
export * from "./MapPlantsLandowners.vue?vue&type=script&lang=js"
import style0 from "./MapPlantsLandowners.vue?vue&type=style&index=0&id=59bd73ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MapPlantsLandowners.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports